// slider-calculator.js
(function() {
  // 1️⃣ Get the current <script> tag (the one that is executing this file)
  const currentScript = document.currentScript;

  // 2️⃣ Create container
  const container = document.createElement("div");
  container.className = "slider-calc-container";
  container.style.maxWidth = "600px";
  container.style.margin = "40px auto";
  container.style.padding = "25px";
  container.style.border = "1px solid #ddd";
  container.style.borderRadius = "12px";
  container.style.fontFamily = "Arial, sans-serif";
  container.style.background = "#fff";
  container.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";

  // 3️⃣ Inner HTML
  container.innerHTML = `
    <h2 style="margin-bottom:20px;color:#0b5a82;text-align:center;">Rental Property Calculator</h2>

    <div class="slider-group">
      <label>Purchase Price: $<span class="price-val">200000</span></label>
      <input type="range" class="price" min="50000" max="1000000" step="1000" value="200000">
    </div>

    <div class="slider-group">
      <label>Down Payment (%): <span class="down-val">20</span>%</label>
      <input type="range" class="down" min="0" max="100" step="1" value="20">
    </div>

    <div class="slider-group">
      <label>Interest Rate (%): <span class="rate-val">6</span>%</label>
      <input type="range" class="rate" min="0" max="20" step="0.1" value="6">
    </div>

    <div class="slider-group">
      <label>Loan Term (years): <span class="term-val">30</span></label>
      <input type="range" class="term" min="1" max="40" step="1" value="30">
    </div>

    <div class="slider-group">
      <label>Monthly Rent: $<span class="rent-val">2000</span></label>
      <input type="range" class="rent" min="100" max="20000" step="50" value="2000">
    </div>

    <div class="slider-group">
      <label>Monthly Operating Expenses: $<span class="expenses-val">500</span></label>
      <input type="range" class="expenses" min="0" max="5000" step="10" value="500">
    </div>

    <h3 style="margin-top:30px;text-align:center;">Results</h3>
    <div class="results" style="background:#f7f7f7;padding:20px;min-height:80px;border-radius:8px;box-shadow:inset 0 2px 4px rgba(0,0,0,0.05);"></div>
  `;

  // 4️⃣ Insert container directly before the current <script> tag
  currentScript.parentNode.insertBefore(container, currentScript);

  // ===== Setup sliders =====
  const price = container.querySelector(".price");
  const down = container.querySelector(".down");
  const rate = container.querySelector(".rate");
  const term = container.querySelector(".term");
  const rent = container.querySelector(".rent");
  const expenses = container.querySelector(".expenses");

  const priceVal = container.querySelector(".price-val");
  const downVal = container.querySelector(".down-val");
  const rateVal = container.querySelector(".rate-val");
  const termVal = container.querySelector(".term-val");
  const rentVal = container.querySelector(".rent-val");
  const expensesVal = container.querySelector(".expenses-val");
  const results = container.querySelector(".results");

  const fmt = v => isFinite(v) ? v.toLocaleString(undefined,{style:'currency',currency:'USD',maximumFractionDigits:0}) : '—';

  function monthlyMortgage(principal, annualRate, years){
    if(principal<=0||years<=0) return 0;
    if(annualRate<=0) return principal/(years*12);
    const r = annualRate/12;
    const n = years*12;
    return principal*(r*Math.pow(1+r,n))/(Math.pow(1+r,n)-1);
  }

  function update(){
    priceVal.innerText = Number(price.value).toLocaleString();
    downVal.innerText = down.value;
    rateVal.innerText = rate.value;
    termVal.innerText = term.value;
    rentVal.innerText = Number(rent.value).toLocaleString();
    expensesVal.innerText = Number(expenses.value).toLocaleString();

    const loanAmount = price.value * (1 - down.value/100);
    const mortgage = monthlyMortgage(loanAmount, rate.value/100, term.value);
    const monthlyCF = rent.value - expenses.value - mortgage;
    const annualCF = monthlyCF*12;
    const NOI = (rent.value - expenses.value)*12;

    results.innerHTML = `
      <p><strong>Loan Amount:</strong> ${fmt(loanAmount)}</p>
      <p><strong>Monthly Mortgage Payment:</strong> ${fmt(mortgage)}</p>
      <p><strong>Monthly Cash Flow:</strong> ${fmt(monthlyCF)}</p>
      <p><strong>Annual Cash Flow:</strong> ${fmt(annualCF)}</p>
      <p><strong>Annual NOI:</strong> ${fmt(NOI)}</p>
    `;
  }

  [price, down, rate, term, rent, expenses].forEach(el => el.addEventListener("input", update));
  update();

  const style = document.createElement("style");
  style.innerHTML = `
    .slider-calc-container .slider-group { margin-bottom:20px; }
    .slider-calc-container label { display:block; font-weight:600; margin-bottom:5px; }
    .slider-calc-container input[type=range] { width:100%; height:8px; border-radius:4px; accent-color:#0b5a82; }
  `;
  document.head.appendChild(style);
})();
